import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RegistrationWrapper, BenefitsWrapper } from '../styles';
import { Box, Card, Flex } from '@/layout';
import { Text } from '@/components/UI/Typography/Text';
import { Button } from '@/components/UI/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { H2, H3 } from '@/components/UI/Typography/Heading';
import { theme } from '@/theme/Theme';
import usePermissionCheck from '@/hooks/usePermissionCheck';
import { errorHandler } from '@/utils/toastHandler';
import { ArrowRightNoBGSVG } from '@/components/Icon';

interface FormStepperProps {
    setCurrentStep: React.Dispatch<React.SetStateAction<string | null>>;
    setActiveStep: React.Dispatch<React.SetStateAction<number>>;
}

const CheckCircleIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" fill="#4CAF50" />
        <path d="M7 12L10.5 15.5L17 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const Introduction = ({ setCurrentStep, setActiveStep }: FormStepperProps) => {
    // @ts-ignore
    const { t } = useTranslation();

    const navigate = useNavigate();
    const [seatchParmas, setSearchParams] = useSearchParams();
    const { isMainAccount } = usePermissionCheck();

    const prevHandler = () => {
        navigate('/home');
    };

    const nextHandler = () => {
        if (!isMainAccount) {
            errorHandler(t('error.permission'));
            return;
        }
        setCurrentStep('2');
        setActiveStep(1);
        setSearchParams({ step: '2' });
    };

    useEffect(() => { }, [t]);

    return (
        <Box maxWidth={930}>
            <Card width={'100%'} padding={'30px 50px !important'}>
                <Flex flexDirection={'column'}>
                    <H2 fontSize={theme.fontSizes.lg} marginBottom={'30px'}>
                        {t('pages.eTrust.goGlobal.steps.step1.mainTitle')}
                    </H2>
                    <H3>
                        {t('pages.eTrust.goGlobal.steps.step1.description')}
                    </H3>
                    <BenefitsWrapper>
                        <div className="benefits-title">{t('pages.eTrust.goGlobal.steps.step1.benefitsTitle')}</div>
                        <div className="benefits-list">
                            {t('pages.eTrust.goGlobal.steps.step1.benefits', { returnObjects: true }).map((benefit: string, index: number) => (
                                <div className="benefit-item" key={index}>
                                    <div className="check-icon">
                                        <CheckCircleIcon />
                                    </div>
                                    <div className="benefit-text">
                                        {benefit}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </BenefitsWrapper>
                    <RegistrationWrapper>
                        <Flex width={'100%'} flexDirection={'column'} justifyContent={'flex-end'}>
                            <Flex>
                                <Button
                                    size={'lg'}
                                    type="button"
                                    variant={'primary'}
                                    marginRight={40}
                                    onClick={nextHandler}
                                >
                                    {t('pages.eTrust.goGlobal.steps.step1.buttonText')}
                                </Button>
                            </Flex>
                        </Flex>
                    </RegistrationWrapper>
                </Flex>
            </Card>
        </Box>

    );
};

export default Introduction;
